import {
  Grid,
  TextField,
  Box,
  Typography,
  Button,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import axios from "axios";

const { REACT_APP_SERVER_URL } = process.env;

const Summary = ({ summary, cvId }) => {
  const [summaryText, setSummaryText] = useState(summary);

  // ✅ API call (PATCH, not PUT, and use "summary")
  const editCvSummary = async ({ cvId, summary }) => {
    try {
      const token = localStorage.getItem("keycloak.token");
      if (!token) throw new Error("No authentication token found");

      const response = await axios.patch(
        `${REACT_APP_SERVER_URL}/cv/summary/${cvId}`,
        { summary }, // ✅ only send summary
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Update summary error:", error.response?.data || error.message);
      throw new Error(error.response?.data?.message || "Failed to update summary");
    }
  };

  // Load from localStorage on mount
  useEffect(() => {
    const data = localStorage.getItem(`summary_${cvId}`);
    if (data !== null) setSummaryText(JSON.parse(data));
  }, [cvId]);

  // Save to localStorage on change
  useEffect(() => {
    localStorage.setItem(`summary_${cvId}`, JSON.stringify(summaryText));
  }, [summaryText, cvId]);

  const handleSaveSummary = async () => {
    try {
      await editCvSummary({ cvId, summary: summaryText });
      toast.success("Summary updated successfully");
    } catch (err) {
      toast.error(`An error occurred while updating summary: ${err.message}`);
    }
  };

  const handleChange = (event) => {
    setSummaryText(event.target.value); // ✅ only update local state
  };

  return (
    <>
      <ToastContainer autoClose={1500} />
      <Grid container spacing={2}>
        <Box display="flex" flexDirection="column" gap={1} sx={{ paddingLeft: 5 }}>
          <Typography variant="h4">Summary</Typography>
          <Typography variant="subtitle1">Professional Overview</Typography>
        </Box>

        <Grid container xs={12} sx={{ marginTop: "30px", paddingLeft: 5 }}>
          <TextField
            id="profile-summary"
            label="Enter Professional Summary"
            multiline
            rows={4}
            value={summaryText}
            onChange={handleChange}
            variant="outlined"
            fullWidth
          />
        </Grid>

        {/* ✅ Next button to save changes */}
        <Grid item xs={12} sx={{ paddingLeft: "1rem", marginTop: 2 }}>
          <Button variant="contained" color="primary" onClick={handleSaveSummary}>
            Next
          </Button>
        </Grid>
      </Grid>
    </>
  );
};

export default Summary;
